import { useEffect, useState } from "react";

import { updateMaintenanceSettings } from "../../services/settingsApi";

function MaintenanceSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        enabled: false,
        message: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                enabled: settings.enabled || false,
                message: settings.message || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateMaintenanceSettings(formData);

            alert("Maintenance settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update maintenance settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Maintenance Settings</h2>

                <div className="settings-grid">

                    <div className="form-group checkbox-group">

                        <label>

                            <input
                                type="checkbox"
                                name="enabled"
                                checked={formData.enabled}
                                onChange={handleChange}
                            />

                            Enable Maintenance Mode

                        </label>

                    </div>

                    <div className="form-group">

                        <label>Maintenance Message</label>

                        <textarea
                            name="message"
                            rows="5"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="The platform is currently under maintenance. Please try again later."
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Maintenance Settings
                </button>

            </div>

        </form>

    );

}

export default MaintenanceSettings;